import { InjectedFormProps, reduxForm } from 'redux-form';

import InputField from 'dashboard/components/FormControls/InputField';
import EmptyRow from 'dashboard/layouts/FormLayout/EmptyRow';
import Form from 'dashboard/layouts/FormLayout/Form';
import Button from 'design-system/components/Button';
import { EMAIL_ADDRESS_REGEX } from 'lib/constants/regexes';
import FormControlField from 'lib/interfaces/FormControlField';
import { isRequired, matchesRegexp, withMessage } from 'lib/utils/formValidation';

const validate = {
  emailAddress: [
    withMessage('Please enter your email address', isRequired),
    withMessage('The email you entered is not valid', matchesRegexp(EMAIL_ADDRESS_REGEX)),
  ],
  password: [withMessage('Please enter your password', isRequired)],
};

const FormLoginComponent = ({ handleSubmit, submitting }: InjectedFormProps) => {
  return (
    <Form onSubmit={handleSubmit}>
      <FormControlField
        label='Email address'
        component={InputField}
        name='emailAddress'
        id='emailAddress'
        type='email'
        disabled={submitting}
        validate={validate.emailAddress}
        placeholder='you@example.com'
      />
      <FormControlField
        label='Password'
        component={InputField}
        name='password'
        id='password'
        type='password'
        disabled={submitting}
        validate={validate.password}
        placeholder='Password'
      />
      <EmptyRow />
      <Button type='submit' disabled={submitting} isPending={submitting}>
        Sign in
      </Button>
    </Form>
  );
};

export interface FormLoginData {
  emailAddress: string;
  password: string;
}

const FormLogin = reduxForm<FormLoginData>({
  form: 'login',
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
})(FormLoginComponent);

export default FormLogin;
